import api from './api';
import { API_ROUTES } from '@/lib/constants';
import { createCrudService } from './crud.factory';
import type { Task, ApiResponse } from '@/types/table';

export const taskService = {
  ...createCrudService<Task>(API_ROUTES.TASKS),

  complete: async (id: string): Promise<ApiResponse<Task>> => {
    const response = await api.patch(`${API_ROUTES.TASKS}/${id}/complete`);
    return response.data;
  },

  bulkComplete: async (ids: string[]) => {
    await api.post(`${API_ROUTES.TASKS}/bulk-complete`, { ids });
  },

  bulkDelete: async (ids: string[]) => {
    await api.post(`${API_ROUTES.TASKS}/bulk-delete`, { ids });
  },
};
